import { Component, Input } from '@angular/core';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { FilterService, BaseFilterCellComponent } from '@progress/kendo-angular-grid';

@Component({
    selector: 'my-dropdown-filter',
  template: `
    <kendo-combobox [(ngModel)]="val"
      (onModelChange)="onChange($event)"
(onChange)="onChange($event)"
      (valueChange)="onChange($event)"
                    [data]="data"
                    textField="label"
                [suggest]="true"
                    [valuePrimitive]="true"
                    valueField="value" placeholder="Select a value">
    </kendo-combobox>
  `
})
export class DropDownListFilterComponent extends BaseFilterCellComponent {

    public get selectedValue(): any {
        const filter = this.filterByField(this.valueField);
        return filter ? filter.value : null;
    }

  
  @Input() public val: any;
    @Input() public filter: CompositeFilterDescriptor;
    @Input() public data: any[];
    @Input() public textField: string;
    @Input() public valueField: string;


    constructor(filterService: FilterService) {
        super(filterService);
    }

  public onChange(value: any): void {
        this.applyFilter(
            value === null ? // value of the default item
                this.removeFilter(this.valueField) : // remove the filter
                this.updateFilter({ // add a filter for the field with the value
                    field: this.valueField,
                    operator: 'eq',
                    value: value
                })
        ); // update the root filter
    }
}
